module.exports = __webpack_public_path__ + "img/pexels-elle-hughes-1549200.2287b26a.jpg";